// src/components/TestResultEditorModal.js
import React, { useMemo, useState, useEffect } from "react";
import CustomModal from "./CustomModal";   // Carbonじゃなく自作
import CustomButton from "./CustomButton";
import { NumberInput, DatePicker, DatePickerInput } from "@carbon/react"; // input系はそのまま使う

// util
const toDateArray = (iso) => (iso ? [new Date(iso)] : []);
const isoOrEmpty = (d) => (d ? d.toISOString() : "");

const FIELD_DEF = {
  sdmt: {
    title: "SDMT（90秒 正答数）",
    fields: [
      { key: "date", type: "date", label: "検査日" },
      { key: "correct", type: "number", step: 1, label: "正答数" },
    ],
  },
  cogeval: {
    title: "CogEval（Zスコア）",
    fields: [
      { key: "date", type: "date", label: "検査日" },
      { key: "z", type: "number", step: 0.1, label: "Z値" },
    ],
  },
  t25fw: {
    title: "T25FW（秒）",
    fields: [
      { key: "date", type: "date", label: "検査日" },
      { key: "sec", type: "number", step: 0.1, label: "秒" },
    ],
  },
  nineHpt: {
    title: "9HPT（秒）",
    fields: [
      { key: "date", type: "date", label: "検査日" },
      { key: "domSec", type: "number", step: 0.1, label: "利き手" },
      { key: "nonDomSec", type: "number", step: 0.1, label: "非利き手" },
    ],
  },
  msnq: {
    title: "MSNQ（合計点）",
    fields: [
      { key: "date", type: "date", label: "検査日" },
      { key: "score", type: "number", step: 1, label: "合計点" },
    ],
  },
  msws12: {
    title: "MSWS-12（合計点）",
    fields: [
      { key: "date", type: "date", label: "検査日" },
      { key: "score", type: "number", step: 1, label: "合計点" },
    ],
  },
  amsq: {
    title: "AMSQ（合計点）",
    fields: [
      { key: "date", type: "date", label: "検査日" },
      { key: "score", type: "number", step: 1, label: "合計点" },
    ],
  },
  mfis: {
    title: "MFIS（合計点）",
    fields: [
      { key: "date", type: "date", label: "検査日" },
      { key: "score", type: "number", step: 1, label: "合計点" },
    ],
  },
};

export default function TestResultEditorModal({ open, onClose, testKey, initial, onSave }) {
  const def = FIELD_DEF[testKey];
  const [local, setLocal] = useState(initial ?? {});
  useEffect(() => setLocal(initial ?? {}), [initial, testKey, open]);

  const header = useMemo(() => (def ? `${def.title} の編集` : "編集"), [def]);
  const updateField = (k, v) => setLocal((p) => ({ ...p, [k]: v }));

  if (!def) return null;

  return (
    <CustomModal
      open={open}
      title={header}
      closeOnOverlay={false} // 外クリックで閉じない
      size="md"
      footer={
        <>
          <CustomButton kind="secondary" onClick={onClose}>
            キャンセル
          </CustomButton>
          <CustomButton kind="primary" onClick={() => onSave(local)}>
            保存
          </CustomButton>
        </>
      }
    >
      <div style={{ display: "grid", gap: "1rem", padding: "0.5rem 0" }}>
        {def.fields.map((f) => {
          if (f.type === "date") {
            return (
              <div key={f.key}>
                <div style={{ fontSize: 12, color: "#525252", marginBottom: 4 }}>
                  {f.label}
                </div>
                <DatePicker
                  dateFormat="Y/m/d"
                  datePickerType="single"
                  value={toDateArray(local[f.key])}
                  onChange={(dates) => updateField(f.key, isoOrEmpty(dates[0]))}
                >
                  <DatePickerInput
                    id={`${testKey}-${f.key}`}
                    labelText=""
                    placeholder="年/月/日"
                  />
                </DatePicker>
              </div>
            );
          }
          if (f.type === "number") {
            return (
              <div key={f.key}>
                <NumberInput
                  id={`${testKey}-${f.key}`}
                  label={f.label ?? "結果"}
                  allowEmpty
                  step={f.step ?? 1}
                  value={local[f.key]}
                  onChange={(_, data) => updateField(f.key, data.value)}
                />
              </div>
            );
          }
          return null;
        })}
      </div>
    </CustomModal>
  );
}
